import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { Spinner } from "@material-tailwind/react";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute() {
  const { user, loading, profileReady } = useAuth();
  const location = useLocation();

  if (loading || !profileReady) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-softbg">
        <div className="glass-card flex items-center gap-3 px-6 py-5 text-brand-800">
          <Spinner className="h-5 w-5" />
          <span className="font-bold">جارٍ تحميل النظام...</span>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return <Outlet />;
}
